
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.875 6.25H3.125a.625.625 0 00-.625.625v2.5c0 .345.28.625.625.625h13.75c.345 0 .625-.28.625-.625v-2.5a.625.625 0 00-.625-.625zM16.25 10v5.625a.624.624 0 01-.625.625H4.375a.625.625 0 01-.625-.625V10","stroke":"#140047","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 6.25v10m3.536-10.884C12.652 6.25 10 6.25 10 6.25s0-2.652.884-3.536a1.875 1.875 0 012.652 2.652v0zm-7.072 0C7.348 6.25 10 6.25 10 6.25s0-2.652-.884-3.536a1.875 1.875 0 00-2.652 2.652v0z","stroke":"#004ADB","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    